import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    DateField,
    Filter,
    DeleteButton,
    ImageField,
} from 'react-admin';

const StudentFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索手机/姓名" source="key" alwaysOn />
        <SelectInput source="Status" label="状态" choices={[
            { id: 1, name: '正常' },
            { id: 0, name: '禁用' },
            { id: 2, name: '注销' },
        ]} />
    </Filter>
);

export const StudentList = props => (
    <List {...props} filters={<StudentFilter />} title="学员管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <ImageField source="Avatar" label="头像" />
            <TextField source="Phone" label="手机号" />
            <TextField source="Name" label="姓名" />
            <TextField source="Gender" label="性别" />
            <TextField source="Company" label="单位" />
            <TextField source="CourseCount" label="课程数" />
            <TextField source="ExamCount" label="考试数" />
            <TextField source="Status" label="状态" />
            <DateField source="LastLoginTime" label="最后登录" showTime />
            <DateField source="CreateTime" label="注册时间" showTime />
            <EditButton />
        </Datagrid>
    </List>
);

export const StudentEdit = props => (
    <Edit {...props} title="编辑学员">
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Phone" label="手机号" />
            <TextInput source="Password" label="新密码(留空不修改)" type="password" />
            <TextInput source="Name" label="姓名" />
            <TextInput source="Avatar" label="头像URL" fullWidth />
            <SelectInput source="Gender" label="性别" choices={[
                { id: 0, name: '未知' },
                { id: 1, name: '男' },
                { id: 2, name: '女' },
            ]} />
            <TextInput source="IdCard" label="身份证号" />
            <TextInput source="Email" label="邮箱" />
            <TextInput source="Company" label="所属单位" />
            <TextInput source="Position" label="职位" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 1, name: '正常' },
                { id: 0, name: '禁用' },
                { id: 2, name: '注销' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const StudentCreate = props => (
    <Create {...props} title="新建学员">
        <SimpleForm>
            <TextInput source="Phone" label="手机号" />
            <TextInput source="Password" label="密码" type="password" />
            <TextInput source="Name" label="姓名" />
            <SelectInput source="Gender" label="性别" defaultValue={0} choices={[
                { id: 0, name: '未知' },
                { id: 1, name: '男' },
                { id: 2, name: '女' },
            ]} />
            <TextInput source="Email" label="邮箱" />
            <TextInput source="Company" label="所属单位" />
            <TextInput source="Position" label="职位" />
            <SelectInput source="Status" label="状态" defaultValue={1} choices={[
                { id: 1, name: '正常' },
                { id: 0, name: '禁用' },
            ]} />
        </SimpleForm>
    </Create>
);
